"use client";

import { useI18n } from "@/contexts/I18nContext";
import {
  LOCALE_NAMES,
  SUPPORTED_LOCALES,
  type Locale,
} from "@/lib/i18n/locales";

interface LanguagePickerProps {
  onSelect?: (locale: Locale) => void;
}

export function LanguagePicker({ onSelect }: LanguagePickerProps) {
  const { locale, setLocale, t } = useI18n();

  return (
    <div className="space-y-1">
      <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide px-3 pt-3 pb-2">
        {t("languagePicker.title")}
      </p>
      <div className="divide-y divide-gray-100 dark:divide-white/5">
        {SUPPORTED_LOCALES.map((code) => {
          const meta = LOCALE_NAMES[code];
          const isSelected = code === locale;
          return (
            <button
              key={code}
              onClick={async () => {
                await setLocale(code);
                onSelect?.(code);
              }}
              className="w-full flex items-center justify-between px-3 py-2.5 hover:bg-gray-50 dark:hover:bg-white/5 transition-colors text-left"
            >
              <span className="flex flex-col">
                <span
                  className={`text-sm ${isSelected ? "font-semibold" : ""}`}
                  style={{
                    color: isSelected
                      ? "var(--accent-color, #00C7BE)"
                      : undefined,
                  }}
                >
                  {meta.native}
                </span>
                {meta.native !== meta.english && (
                  <span className="text-xs text-gray-500">{meta.english}</span>
                )}
              </span>
              {isSelected && (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ color: "var(--accent-color, #00C7BE)" }}
                >
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
